__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "mfe-accont-management";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@aws-amplify/auth", "6.0.16", () => (() => (__webpack_require__(34332))), 1);
			register("@aws-amplify/core", "6.0.16", () => (() => (__webpack_require__(31933))), 1);
			register("@mui/material", "5.15.6", () => (() => (__webpack_require__(59983))), 1);
			register("react-dom", "17.0.2", () => (() => (__webpack_require__(54164))), 1);
			register("react-redux", "7.2.9", () => (() => (__webpack_require__(60364))), 1);
			register("react-router-dom", "6.21.3", () => (__webpack_require__.e(276).then(() => (() => (__webpack_require__(46276))))));
			register("react", "17.0.2", () => (() => (__webpack_require__(72791))), 1);
			register("redux-saga", "1.3.0", () => (() => (__webpack_require__(95792))), 1);
			register("redux", "4.2.1", () => (() => (__webpack_require__(20097))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};